
import { accent0, accent1, accent2, accent4 } from '../globals/colors';
import styled, { keyframes } from 'styled-components';
import { excludeProps } from '../utilities/excludeProps';
import { animationDuration, circumference, strokeWidth } from './Loader.shared';

export var animateRotation = keyframes(["100%{transform:rotate(360deg);}"]);





export var animateArcLength = keyframes(["0%{stroke-dasharray:0,", "px;stroke-dashoffset:0;}50%{stroke-dasharray:", "px,", "px;stroke-dashoffset:-", "px;}100%{stroke-dasharray:0,", "px;stroke-dashoffset:-", "px;}"],

circumference,



circumference * 1.5, circumference,
circumference * .5,


circumference,
circumference + 1);



/**
 * For some reason, css variables in Edge-legacy don't work in this keyframes animation.
 * Need to revert to actual values here for Edge.
 */
export var animateColors = keyframes(["0%,100%{stroke:", ";}25%{stroke:", ";}50%{stroke:", ";}75%{stroke:", ";}"],

accent0,


accent1,


accent2,


accent4);








var loaderRootConfig = excludeProps(['show', 'size']);

export var Loader_Root = styled.div.withConfig(loaderRootConfig).withConfig({ displayName: "Loaderstyles__Loader_Root", componentId: "sc-1vwfxoo-0" })(["align-items:center;display:flex;flex-grow:1;justify-content:center;position:relative;visibility:", ";width:100vw;height:100vh;svg{animation:", " ", "s linear infinite;height:", ";width:", ";circle{animation:", " ", "s ease-in-out infinite,", " ", "s ease-in-out infinite;fill:none;stroke-linecap:round;stroke-width:", "px;transform-origin:center;}}"],





function (_ref) {var show = _ref.show;return show ? 'visible' : 'hidden';},




animateRotation, animationDuration,
function (_ref2) {var size = _ref2.size;return "".concat(size, "rem");},
function (_ref3) {var size = _ref3.size;return "".concat(size, "rem");},


animateArcLength, animationDuration,
animateColors, animationDuration * 4,


strokeWidth);
//# sourceMappingURL=Loader.styles.js.map